module.exports = new __parcel__URL__("incidents-task-one-illustration-dark.ac414e13.png").toString();